import b from 'b_';
import React from 'react';
import cx from 'classnames';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

// @ts-ignore
import { IconPencil } from 'common.components/icon/icon';

import './students__student-name-pencil-icon.scss';

interface Props {
    className?: string;
    disabled: boolean;
    handleNameChange: () => void;
}

export const StudentNamePencilIcon = ({ disabled, handleNameChange, className }: Props) => {
    return (
        <span
            className={cx(b('students', 'table-student-edit-name', { disabled }), className)}
            {...accessibleClick(handleNameChange)}
        >
            <IconPencil disabled={disabled} mix="students__edit-name-icon" />
        </span>
    );
};
